<mat-card class="mb-25 tagus-card current-rate-box" [class.component-rtl-enabled]="themeService.isRTLEnabled()">
    <mat-card-header class="border-bottom" matBadgePosition="after" matBadgeColor="accent" matBadgeSize="large">
        <div class="icon badge" [matBadge]="store.computedProductResource().value()?.data?.length ?? '0'">
            <h5 class="mb-0">Products</h5>
        </div>

    </mat-card-header>
    <mat-card-content>
        <ng-scrollbar visibility="hover" style="min-height: 30vh;max-height: 59vh;">
            <div class="row height-100">
                <div class="col w-100">
                    @if(productResourceRef()?.isLoading()){
                    @for(loader of loader;track $index){
                    <div class="row">
                        <div class="col-12 mb-8 overflow-hidden">
                            <div class="fade-in">
                                <ngx-skeleton-loader count="1" [theme]="getTheme()" />
                            </div>
                        </div>
                    </div>
                    }
                    }@else{
                    @for(product of store.computedProductResource().value()?.data;track product.productID || $index){
                    <div tabindex="" class="box mb-10" (click)="selectProduct(product)">
                        <div class="title d-flex align-items-center justify-content-space-between">
                            <div class="d-flex align-items-center">
                                <h4 class="mb-0">{{product['template']['selection']['productCategory']}}</h4>
                                <span class="badge rounded-pill text-soft-tagus ms-10">{{product.status}}</span>
                            </div>
                            <!-- <span class="up"><i class="flaticon-trend"></i></span> -->
                        </div>
                        <span class="d-block mb-10 gray-color">{{product?.template?.productIdentifier}}</span>
                        <div class="d-md-flex meta border-none justify-content-space-between align-items-center mt-10">
                            <ul class="list mb-0 d-md-flex mt-0 ps-0">
                                <li class="gray-color fw-semibold fs-13">
                                    Contract Type
                                    <div class="d-flex align-items-center">
                                        <span
                                            class="d-block fw-semibold fs-10">{{product?.template?.terms?.[0]['contractType']
                                            ?? '--'}}</span>
                                    </div>
                                </li>
                                <li class="gray-color fw-semibold fs-13">
                                    Currency
                                    <div class="d-flex align-items-center">
                                        <span
                                            class="d-block fw-semibold fs-10">{{product?.template?.terms?.[0]['currency']
                                            ?? '--'}}</span>
                                    </div>
                                </li>
                            </ul>
                        </div>

                        <a class="link-btn main-hover-color"><i class="flaticon-chevron"></i></a>
                    </div>
                    }@empty{
                    <div class="text-center ">
                        <h4> <span class="material-symbols-outlined">
                                search
                            </span></h4>
                        <h5>No Data Found</h5>
                    </div>
                    }
                    }
                    <!-- @for(product of productListInput() ?? [];track product.productID){
                        <div tabindex="" class="box mb-10" (click)="selectProduct(product)">
                            <div class="title d-flex align-items-center justify-content-space-between">
                                <div class="d-flex align-items-center">
                                    <h4 class="mb-0">{{product['template']['selection']['productCategory']}}</h4>
                                    <span class="badge rounded-pill text-soft-tagus ms-10">{{product.status}}</span>
                                </div>
                            </div>
                            <span class="d-block mb-10 gray-color">{{product?.template?.productIdentifier}}</span>
                            <div class="d-md-flex meta border-none justify-content-space-between align-items-center mt-10">
                                <ul class="list mb-0 d-md-flex mt-0 ps-0">
                                    <li class="gray-color fw-semibold fs-13">
                                        Contract Type
                                        <div class="d-flex align-items-center">
                                            <span
                                                class="d-block fw-semibold fs-10">{{product?.template?.terms?.[0]['contractType']
                                                ?? '--'}}</span>
                                        </div>
                                    </li>
                                    <li class="gray-color fw-semibold fs-13">
                                        Currency
                                        <div class="d-flex align-items-center">
                                            <span
                                                class="d-block fw-semibold fs-10">{{product?.template?.terms?.[0]['currency']
                                                ?? '--'}}</span>
                                        </div>
                                    </li>
                                </ul>
                            </div>
    
                            <a class="link-btn main-hover-color"><i class="flaticon-chevron"></i></a>
                        </div>
    
                        }@empty{
                        NO data
                        } -->
                </div>
            </div>
        </ng-scrollbar>
    </mat-card-content>
</mat-card>